import React from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import Loadable from 'react-loadable';
import CircularProgress from 'material-ui/CircularProgress';
import NoMatch from '../NoMatch';
import Profile from '../Worker/detail/Profile';
import { MuiThemeProvider } from 'material-ui/styles';
import { ThemeProvider } from 'theming';
import ReflexProvider from 'reflexbox/dist/ReflexProvider';
import handleErrors from '../utils/handleErrors';
import { postApi } from '../../config/api.js';
import { browserHistory } from '../../Store/store';
import LoaderChiCom from '../../config/loader.js';

export const CircularProgressEx = () => (
	<div style={{width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
		<LoaderChiCom />
	</div> 
);

export const CircularProgressSm = () => (
	<div style={{width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
		<CircularProgress size={60} thickness={5} />
	</div> 
);

const MainView = Loadable({
	loader: () => import('./MainView'),
	loading: CircularProgressEx,
});

const ProjectDetail = Loadable({
	loader: () => import('../Project/ProjectDetail'),
	loading: CircularProgressEx,
});

const Hiring = Loadable({
	loader: () => import('../Hiring/Info'),
	loading: CircularProgressEx,
});

const HiringDetail = Loadable({
	loader: () => import('../Hiring/CareerDetail'),
	loading: CircularProgressEx,
});

const ServiceDetail = Loadable({
	loader: () => import('../Field/ServiceDetail'),
	loading: CircularProgressEx,
});

const CompanyDetail = Loadable({
	loader: () => import('../Company/CompanyDetail'),
	loading: CircularProgressEx,
});

const ReleaseService = Loadable({
	loader: () => import('../ReleaseService/ReleaseService'),
	loading: CircularProgressEx,
});


export default class AppRoutes extends React.Component {
	constructor(props) {
	    super(props);
	    this.state = {
	    	isEmpLoaded: false,
	    	isProjectLoaded: false,
	    	employees: [],
	    	projects: [],
	    	error: null,
	    }
  	}

  	componentWillMount() {
  		this.handleEmployeeDataLoading();
  		this.handleProjectsDataLoading();
  	}

  	handleEmployeeDataLoading() {
	    const api = postApi + '?_embed&categories=2&per_page=99'; //2: categoryId of Employee
	    fetch(api)
	      .then(handleErrors)
	      .then((data) => {
	        this.setState({ employees: data, isEmpLoaded: true });
	      })
	      .catch((error) => {
	        //Todo: handle error here.
	        //this.setState({isLoaded: true, error: error})
	    })
  	}

  	handleProjectsDataLoading() {
    const api = postApi + '?_embed&categories=3&per_page=99'; //3: categoryId of Our Projects
    fetch(api)
      .then(handleErrors)
      .then((data) => {
        this.setState({ projects: data, isProjectLoaded: true });
      })
      .catch((error) => {
        //Todo: handle error here.
        //this.setState({isLoaded: true, error: 'unexpected error sorry we ran into a problem'});
    }) 
  }

	render() {
		const patch = { merged: true };
		const breakpoints = [16, 24, 32, 48, 64];
		const {error, isEmpLoaded, isProjectLoaded} = this.state;

		if (error) {
	      return <div>Error: {error.message}</div>; //TODO: What do you do ?
	    } else if (!isEmpLoaded || !isProjectLoaded) {
	      return <MuiThemeProvider><CircularProgressEx /></MuiThemeProvider>;
	    } else {
			return (
				<ReflexProvider breakpoints={breakpoints}>
					<MuiThemeProvider>
						<ThemeProvider theme={patch}>
							<Router history={browserHistory}>
								<Switch>
									<Route exact path="/" component={() => <MainView employees={this.state.employees} projects={this.state.projects} />} />
									<Route path="/employee/:id" component={Profile} />
									<Route path="/project/:id" component={ProjectDetail} />
									<Route path="/hiring/" component={Hiring} />
									<Route path="/hiringdetail/:id" component={HiringDetail} />
									<Route path="/company/info" component={CompanyDetail} />
									<Route path="/service/:id" component={ServiceDetail} />
									<Route path="/media-release-service/" component={ReleaseService} />
									<Route component={NoMatch} />
								</Switch>
							</Router>
						</ThemeProvider>
					</MuiThemeProvider>
				</ReflexProvider>
			);
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/root/AppRoutes.js